import api from "./api";

const PaymentInformationAPI = {
    getByUserPlanSubscriptionId: (id) => api.get(`/payment-information/user-plan-subscription/${id}`),
    getById: (id) => api.get(`/payment-information/details/${id}`),
    paymentSuccess: (intentId) => api.get(`/stripe-payments/payment-success/${intentId}`),
    paymentFail: (intentId) => api.get(`/stripe-payments/payment-fail/${intentId}`)
};

export default PaymentInformationAPI;